export default {

  component: {
    jobAdList: {
      title: 'Open job positions',
      jobs: 'jobs',
      noJobAds: 'There are currently no open positions.',
    },

    jobAdCard: {
      openUntil: date => `Open until ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Thank you.',
      readyInfo: 'Your application has now been received and the recruiter will get back to you shortly.',
      luck: 'Best of luck!',
    },

    jobAdSeeYou: {
      title: 'Thank you.',
      description: 'Your application is saved and we have sent link to continue application later on.',
    },

    unpublished: {
      title: 'Unpublished',
      info: 'The job ad has not been published yet.',
    },
  },

  page: {
  },

}
